import { handleSessionOut } from "../Components/Components";
import { getToken } from "./tokenStore";
 
const authUrl = process.env.REACT_APP_AUTH_URL;
const nimbleUrl = process.env.REACT_APP_NIMBLE_URL;
const venderUrl = process.env.REACT_APP_VENDER_URL;
// const exchange = process.env.REACT_APP_AUTH_URL2;
 
export const login = async (userName, password, url) => {
  const response = await fetch(`${authUrl}/Login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userName, password, url }),
  });
 
  if (!response.ok) throw new Error("Login failed");
 
  const id = await response.json();
 
  return id.authID;
};
 
async function validateToken(token) {
  let res = await fetch(`${authUrl}/v1/OpenApiauth/ValidateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  let data = await res.json();
 
  if (data.statusCode !== 200) {
    await handleSessionOut();
    return false;
  }
 
  return true;
}
 
export const exchangeOAuth = async (url, authID) => {
  let response = await fetch(`${authUrl}/${url}/OpenApiauth/ExchangeOAuth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token: authID }),
  });
 
  if (!response.ok) throw new Error("ExchangeOAuth failed");
  const data = await response.json();
  return data;
};
 
// export async function refreshToken( token,refAuthID) {
//   const res = await fetch(`${refreshUrl}/RefreshToken`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
 
//     },
//     body: JSON.stringify({ refAuthID : refAuthID }),
//   });
 
//   const data = await res.json();
//   if (data.statusCode === 200) {
//     return {
//       token: data.token,
//       minutesToExpire: data.minutesToExpire,
//       refAuthID: data.refAuth,
//     };
//   }
//   let name = "sessionout";
//   window.parent.postMessage(name, "*");
//   await new Promise((resolve) => setTimeout(resolve, 500));
//   return null;
// }
 
export async function refreshToken(token, url, refAuthID) {
  const res = await fetch(`${authUrl}/${url}/OpenApiauth/RefreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ refAuthID }),
  });
 
  const data = await res.json();
 
 
 
   if (data.statusCode === 200) {
    return {
      token: data.token,
      minutesToExpire: data.minutesToExpire,
      refAuthID: data.refAuth,
    };
  }
  await handleSessionOut();
  return null;
}
 
export const getCorporations = async (setSelects) => {
  const token = getToken();
 
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const response = await fetch(`${nimbleUrl}/GetCorporationsByBusinessType?BusinessType=3`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    throw new Error("Failed to fetch corporations");
  }
 
  const corp = await response.json();
  const corporations = corp.Corporations || [];
  const setSelect = setSelects;
  corporations.unshift(setSelect);
  return corporations;
};
 
 
export async function getPrivileges(menuID) {
   const token = getToken();
 
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  let res = await fetch(`${nimbleUrl}/Previlages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      RoleID: "000000000000000000000000000000000000",
      UserID: menuID,
      MenuIds: menuID,
    }),
  });
 
  let data = await res.json();
  let privilages = data["Details"];
 
  return privilages.length > 0 ? privilages[0] : {};
}
 
export async function fetchBillPrivileges(menuID, billPrivileges) {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  let res = await fetch(`${nimbleUrl}/Previlages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      RoleID: "000000000000000000000000000000000000",
      UserID: menuID,
      MenuIds: `${menuID},${billPrivileges.BillEntry},${billPrivileges.BillPayment}`,
    }),
  });
 
  let data = await res.json();
  let privilages = data["Details"];
 
  return privilages.length > 0 ? privilages : {};
}
// -----
 
export const getBillEntryPreferences = async (menuID) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}GetBillEntryPreferences?CorpID=${menuID}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data;
};
 
// ----
 
// Fetch PCs by Corporation ID
 
export const getPCsByCorporation = async (corpId ) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
  const url = `${nimbleUrl}/GetPCsByBusinessType?CorporationId=${corpId}&BusinessType=3&IsActive=false`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  if (Array.isArray(data?.ListInfo)) {
    const pcsList = data.ListInfo;
    const setSelect = { ID: "select", Name: "-Select-" };
    pcsList.unshift(setSelect);
    return data.ListInfo;
  }
};
export const getBankAccounts = async (corpID, accId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${nimbleUrl}/accounts?AccountTypeID=${accId}&IsInactive=false&CorpID=${corpID}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  if (Array.isArray(data?.Accounts)) return data.Accounts;
};
 
export const getVenderlist = async (corpID) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}GetVendorsList?CorpID=${corpID}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  if (Array.isArray(data?.vendors)) {
    const vendorList = data.vendors;
    const setSelect = { id: "select", name: "-Select-" };
    vendorList.unshift(setSelect);
    return vendorList;
  }
};
 
export const billImport = async (formData,payload) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const { CorpId, PcId, VendorId, BankAccountId, DiscountAccountId } = payload;
 
  const url = `${venderUrl}DCP/BillImport?CorpId=${CorpId}&PcId=${PcId}&VendorId=${VendorId}&BankAccountId=${BankAccountId}&DiscountAccountId=${DiscountAccountId}`;
 
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`BillImport failed: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  return data;
};
 
export const GetUploadList = async (
  corpId,
  fDate,
  tDate,
  statusFilter,
) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/BillImport/List/${corpId}?status=${statusFilter}&fromDate=${fDate}&toDate=${tDate}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  return data;
};
 
export const deleteUploadList = async ( uploadId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  try {
    const response = await fetch(
      `${venderUrl}DCP/DeleteDCPBills/${uploadId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
 
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in deleteUploadList:", error);
    return null;
  }
};
 
export const unmappedPurposes = async ( id) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/BillImport/${id}/UnmappedPurposes`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  return data;
};
 
export const billImportPurposes = async (corpId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/BillImport/Purposes/${corpId}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }
 
  const data = await response.json();
  return data;
};
 
export const downloadFileAPI = async (fileType, id) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const response = await fetch(
    `${venderUrl}DCP/BillImport/Download/${fileType}/${id}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`, // if needed
      },
    },
  );
 
  if (!response.ok) {
    throw new Error(`Failed to download ${fileType} file`);
  }
 
  const contentType = response.headers.get("content-type") || "";
  const blob = await response.blob();
 
  return { blob, contentType };
};
 
export const loadCorporationDefaultPaymentAccount = async (corpId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}LoadCorporationDefaultPaymentAccount?CorpID=${corpId}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  const data = await response.json();
  return data;
};
 
export const loadPaymentMethods = async () => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}LoadPaymentMethods`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  const data = await response.json();
  return data.listInfo;
};
 
export const LoadLastUsedAccount = async (payload) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}LoadLastUsedAccount`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
 
  const data = await response.json();
  return data;
};
 
export const discountConfig = async (corpId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DiscountConfig/Get?CorpID=${corpId}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  const data = await response.json();
  return data;
};
 
export const getPCnumber = async (pcId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${nimbleUrl}/profitCenter/${pcId}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data;
};
 
export const getLatestVendorID = async (corpId) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/GetLatestVendorID?corporationId=${corpId}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data;
};
 
export const billImports = async (uploadId, body) => {
    const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/BillImport/${uploadId}/continue`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: body,
  });
 
  // const data = await response.json();
  return response;
};
 
export const updateDiscountAccountAPI = async (body) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DiscountConfig/Save`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
 
  // const data = await response.json();
 
  const data = await response.json();
  return data;
};
 
export const attentionBillImport = async (id, payload) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/BillImport/${id}/continue`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
 
  // const data = await response.json();
 
  const data = await response.json();
  return data;
};
 
export const getMinAndMaxDate = async (id) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/GetMinAndMaxDate?id=${id}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data;
};
 
export const getDeleteAttentionDetails = async (id) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}DCP/GetDeleteAttentionDetails/${id}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data;
};
 
export const userApprovals = async (transactionType) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
 
  const url = `${venderUrl}GetUserApprovalType?TransactionType=${transactionType}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await resp.json();
  return data.status;
};